/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';

/**
 * `Payload` type.
 */

type Payload = {
  apiKey: string;
  phoneNumber: string;
  externalUserId: string;
};

/**
 * Post phoneNumber.
 */

export async function postPhoneNumber(client: AxiosInstance, payload: Payload): Promise<string> {
  const { phoneNumber, externalUserId, apiKey } = payload;

  return await client
    .post(
      resolveAppUrl('integrationsConsentPhoneNumber'),
      {
        phoneNumber,
        glinttUserId: externalUserId
      },
      {
        headers: {
          'X-Api-Secret': apiKey
        }
      }
    )
    .then(({ data }) => data.data);
}

/**
 * Export `usePostConsentPhoneNumber`.
 */

export function usePostConsentPhoneNumber() {
  const client = useRequestProvider();

  return useMutation({
    mutationFn: async (payload: Payload) => {
      return await postPhoneNumber(client, payload);
    }
  });
}
